/**
 * Спільна логіка порівняльних таблиць (ComparativeTableDefault, ComparativeTableLotGroups):
 * сірі однакові значення, рядки критеріїв, вибір колонок → snackbar 'compare'
 *
 * Хост може визначити:
 *  - compareSnackbarOptions — додаткові поля для $_openSnackbar
 *  - afterCompareAction(items) — викликається після дії в snackbar (вибір/зняття переможця)
 *  - selectedToElements(selected) — перетворює значення чекбоксів на пропозиції для snackbar
 *    (коли чекбокси прив'язані не до самих об'єктів)
 */
export default {
  data() {
    return {
      selected: [],
    }
  },
  methods: {
    /** значення key однакове в усіх (більше ніж одній) колонках */
    $_getSame(key, items) {
      return items.length > 1 && items.every((item, i, arr) => !arr[i + 1] || item[key] == arr[i + 1][key])
    },
    /**
     * Рядки критеріїв { text, value: 'criteria' } з all_criteria пропозицій, без дублів по назві.
     * Група 'default' (стандартні умови) має items-об'єкт, а не масив — вона виводиться
     * окремими рядками ($_defaultCriteriaKeys), тому пропускається
     *
     * @param {Array} items пропозиції
     * @param {Array|null} groupNames лише ці групи all_criteria ('ToLot', 'ToTender'); null — усі
     */
    $_criteriaKeys(items, groupNames = null) {
      const result = []
      items.forEach(item => {
        item?.all_criteria?.forEach(group => {
          if (!Array.isArray(group.items) || (groupNames && !groupNames.includes(group.name))) {
            return
          }
          group.items.forEach(crit => result.push({ text: crit.title, value: 'criteria' }))
        })
      })
      return this.$_.uniqBy(result, 'text')
    },
    /** рядки стандартних умов, якщо вони заповнені хоч в одній пропозиції без критеріїв */
    $_defaultCriteriaKeys(items) {
      const hasDefault = items.some(item => item && !item.criteria?.length
        && (item.termsPayment || item.deliveryTime || item.termsDelivery || item.warrantyYears))
      if (!hasDefault) {
        return []
      }
      return [
        { text: this.$t('Tenders.DeliveryTimeInDays'), value: 'deliveryTime' },
        { text: this.$t('Tenders.Guarantee'), value: 'warrantyYears' },
        { text: this.$t('Tenders.TermsOfDelivery'), value: 'termsDelivery' },
        { text: this.$t('Tenders.TermsOfPayment'), value: 'termsPayment' },
      ]
    },
    resetCompareSelection() {
      this.$forceUpdate()
      this.selected = []
    },
  },
  watch: {
    selected(val) {
      if (val.length > 0) {
        const elements = this.selectedToElements ? this.selectedToElements(val) : val
        this.$_openSnackbar({
          name: 'compare',
          elements,
          tender: this.tender,
          ...(this.compareSnackbarOptions || {}),
          // «скасувати вибір» — лише скидання чекбоксів
          rejectChoosed: this.resetCompareSelection,
          // callback — після дії (вибір/зняття переможця)
          callback: () => {
            if (this.afterCompareAction) {
              this.afterCompareAction(elements)
            }
            this.resetCompareSelection()
          },
        })
      } else if (val.length == 0) {
        this.$_closeSnackbar()
      }
    },
  },
}
